import { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { VIDEO_CONFIG } from "../constants/video-config";

const FIRST_TIME_USER_KEY = VIDEO_CONFIG.FIRST_TIME_USER_KEY;

export const useFirstTimeUser = () => {
    const { user, loading: authLoading } = useAuth();
    const userId = user?.id || null;
    const storageKey = userId ? `${FIRST_TIME_USER_KEY}:${userId}` : null;
    const [isFirstTime, setIsFirstTime] = useState(null);
    const [hasSeenVideo, setHasSeenVideo] = useState(false);

    useEffect(() => {
        // Wait for auth to resolve and a real user id to be available
        if (authLoading || !storageKey) {
            setIsFirstTime(null);
            return;
        }

        const hasSeen = localStorage.getItem(storageKey);
        setHasSeenVideo(hasSeen === "true");
        setIsFirstTime(!hasSeen);
    }, [authLoading, storageKey]);

    const markVideoAsSeen = () => {
        if (!storageKey) return;
        localStorage.setItem(storageKey, "true");
        setHasSeenVideo(true);
        setIsFirstTime(false);
    };

    const resetFirstTimeState = () => {
        if (!storageKey) return;
        localStorage.removeItem(storageKey);
        setHasSeenVideo(false);
        setIsFirstTime(true);
    };

    return {
        isFirstTime,
        hasSeenVideo,
        markVideoAsSeen,
        resetFirstTimeState,
        isLoading: authLoading || isFirstTime === null
    };
}; 